import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { css } from "styled-components"
import Carousel from "../../../components/developer-tools/carousel"
import ClientSuccess from "../../../components/developer-tools/client-success"
import DataExport from "../../../components/developer-tools/data-export"
import Hero from "../../../components/developer-tools/hero"
import PrebuiltApps from "../../../components/developer-tools/prebuilt-apps"
import SdkOverview from "../../../components/developer-tools/sdk-overview"
import Contact from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"
import Layout from "../../../components/shared/layout"
import PlatformLayers from "../../../components/shared/platform-layers"
import SEO from "../../../components/shared/seo"
import {
  IFluidImageQuery,
  IFluidImageQueryArray,
} from "../../../design-system/types/imageQuery.types"

interface ILogosStaticQuery {
  desktopLogos: IFluidImageQuery
  tabletLogos: IFluidImageQuery
  mobileLogos: IFluidImageQueryArray
}

interface IDeveloperToolsPage {
  location: any
}

export default function DeveloperToolsPage({ location }: IDeveloperToolsPage) {
  const { desktopLogos, tabletLogos, mobileLogos } =
    useStaticQuery<ILogosStaticQuery>(graphql`
      query {
        desktopLogos: file(
          relativePath: {
            eq: "1_SOLUTIONS/Developer Tools/Clients/client logos desk.png"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        tabletLogos: file(
          relativePath: {
            eq: "1_SOLUTIONS/Developer Tools/Clients/client logos tablet.png"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1024) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mobileLogos: allFile(
          filter: {
            relativeDirectory: {
              eq: "1_SOLUTIONS/Developer Tools/Clients/mobile"
            }
          }
          sort: { fields: base }
        ) {
          edges {
            node {
              id
              base
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    `)
  return (
    <Layout location={location}>
      <SEO
        title="Developer Tools"
        description="Mappedin's robust developer tools enable partners to build custom mapping solutions and integrate with other technology providers."
      />
      <Hero
        title="Developer Tools"
        description="Mappedin’s platform enables customers, partners, and developers to build unique indoor mapping experiences. Along with the Mappedin-built digital twin of your venue, our extensive toolset works across a variety of industries and spaces."
      />
      <PlatformLayers />
      <Carousel />
      <SdkOverview />
      <DataExport />
      <ClientSuccess
        description="We continually improve our developer tools and value customer input. This dedication to customer success ensures that your voice is heard as we evolve our products."
        supportItems={[
          "24/7 Support",
          "Interactive Town Halls",
          "Continuous Training",
          "Expert Integrations Team",
          "Developer Documentation",
          "Getting Started Guides",
          "Sample Applications",
        ]}
        desktopLogos={desktopLogos}
        tabletLogos={tabletLogos}
        mobileLogos={mobileLogos}
        clientGridVariants={[
          null,
          css`
            max-width: 488px;
          `,
        ]}
      />
      <PrebuiltApps
        description="Check out our pre-built applications to discover other products that Mappedin offers."
        buttonText="Explore Pre-Built Apps"
        buttonHref="https://www.mappedin.com/mapping/applications/" // External link to trigger new tab
      />
      <Contact />
      <Footer />
    </Layout>
  )
}
